/**
 * CyclePositionIndicator — soft dots showing cycle position within the month
 * e.g. ● ● ○ ○  "Cycle 2 of 4 this month"
 * No streaks, no gamification — just awareness.
 */
import { useRhythm } from "./RhythmProvider";

export function CyclePositionIndicator() {
  const { rhythm, loading } = useRhythm();

  if (loading) return null;

  const rhythmType = rhythm.rhythm_type;
  const now = new Date();
  const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  let totalCycles = 0;
  let currentCycle = 0;

  if (rhythmType === "weekly") {
    totalCycles = Math.ceil(monthEnd.getDate() / 7);
    currentCycle = Math.ceil(now.getDate() / 7);
  } else if (rhythmType === "fortnightly") {
    totalCycles = 2;
    currentCycle = now.getDate() <= 15 ? 1 : 2;
  } else if (rhythmType === "per_pay_cycle") {
    totalCycles = Math.ceil(monthEnd.getDate() / 7);
    currentCycle = Math.ceil(now.getDate() / 7);
  } else {
    // monthly — single cycle, nothing to show
    return null;
  }

  if (totalCycles <= 1) return null;

  return (
    <div
      className="flex items-center gap-2.5 mb-4"
      data-testid="cycle-position-indicator"
    >
      <div className="flex items-center gap-1">
        {Array.from({ length: totalCycles }, (_, i) => (
          <div
            key={i}
            className={`w-2 h-2 rounded-full transition-colors duration-300 ${
              i < currentCycle
                ? "bg-amber-500/60 dark:bg-amber-400/50"
                : "bg-slate-200 dark:bg-slate-700"
            }`}
            data-testid={`cycle-dot-${i}`}
          />
        ))}
      </div>
      <span className="text-xs text-muted-foreground">
        Cycle {currentCycle} of {totalCycles} this month
      </span>
    </div>
  );
}
